import { ProductImport } from 'components/product/product-import/ProductImport'
import { useState } from 'react'
import { STEPS_IMPORT_PRODUCT } from 'constants/constant'
import { UploadXLSXFileContainer } from './upload-xlsx-file/UploadXLSXFileContainer'
import { ColumnMappingContainer } from './column-mapping/ColumnMappingContainer'
import { ImportContainer } from './import/ImportContainer'
import { DoneContainer } from './done/DoneContainer'

export const ProductImportContainer = () => {
    const [activeStep, setActiveStep] = useState(1)
    const [payload, setPayload] = useState({ file: {}, is_update: false, mapping_fields: [] })
    const [importResult, setImportResult] = useState({})

    const setPayloadData = (payload) => {
        setPayload(payload)
    }

    const setImportResultData = (item) => {
        setImportResult(item)
    }

    const onChangeStep = (step) => {
        setActiveStep(step)
    }

    const STEP_CONTENT = [
        <UploadXLSXFileContainer payload={payload} onChangeStep={onChangeStep} setPayloadData={setPayloadData} />,
        <ColumnMappingContainer payload={payload} onChangeStep={onChangeStep} setPayloadData={setPayloadData} />,
        <ImportContainer payload={payload} onChangeStep={onChangeStep} setImportResultData={setImportResultData} />,
        <DoneContainer importResult={importResult} />,
    ]

    const props = {
        steps: STEPS_IMPORT_PRODUCT,
        stepContent: STEP_CONTENT,
        activeStep,
    }

    return <ProductImport {...props} />
}
